import {
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@material-ui/core";
import React, { memo, useContext } from "react";
import { createPortal } from "react-dom";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import { useProLogsTheme } from "../../../common/hooks/useProLogsTheme";
import { AppBarFiltersContainerContext } from "../app-bar-filters/AppBarFiltersContainerContext";

interface Props {
  onSearchTextChange: (searchText: string) => void;
  searchText: string;
}

export const AppBarSimpleSearchField = memo(
  ({ onSearchTextChange, searchText }: Props) => {
    const { container: appbarFiltersContainer } = useContext(
      AppBarFiltersContainerContext
    );

    const darkTheme = useProLogsTheme("dark");

    const handleTextChange = (text: string) => {
      onSearchTextChange(text);
    };

    const handleChange: React.ChangeEventHandler<
      HTMLInputElement | HTMLTextAreaElement
    > = (e) => {
      handleTextChange(e.target?.value ?? "");
    };

    return appbarFiltersContainer
      ? createPortal(
          <ThemeProvider theme={darkTheme}>
            <TextField
              variant="outlined"
              margin="dense"
              className="appbar-filter appbar-simple-search-field"
              label=""
              value={searchText}
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {!!searchText.length && (
                      <IconButton onClick={() => handleTextChange("")}>
                        <ClearIcon className="search-icon" />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className="search-icon" />
                  </InputAdornment>
                ),
              }}
            />
          </ThemeProvider>,
          appbarFiltersContainer
        )
      : null;
  }
);
